import { useEffect, useState } from "react"
import { getPresentacionById, postPresentacion, patchPresentacion } from "../../services/PresentacionesServices"
import { PresentacionesFormContext } from "./PresentacionesContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const PresentacionesFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getPresentacionByIdData(id)
    }, [])

    const getPresentacionByIdData = async (id) => {
        let res = await getPresentacionById(id)
        if (res) setReport(res)
    }

    const postPresentacionData = async (body) => {
        const res = await postPresentacion(body)
        if (res) navigate("/presentaciones");
    }

    const patchPresentacionData = async (id, body) => {
        const res = await patchPresentacion(id, body)

        if (res) navigate("/presentaciones");
    }


    return <PresentacionesFormContext.Provider value={{
        report,
        postPresentacionData,
        patchPresentacionData,
    }} >
        {children}
    </PresentacionesFormContext.Provider>
}